import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  confirm (event: Event): void {
    event.preventDefault()
    event.stopPropagation()

    const modal = this.element.closest('dialog') as HTMLDialogElement
    if (modal == null) return

    const selectId = modal.dataset.selectId
    const newStatus = modal.dataset.newStatus

    // Close modal
    modal.close()

    // Dispatch custom event for form controller to handle
    document.dispatchEvent(new CustomEvent('evidence-status-confirmed', {
      detail: { selectId, newStatus },
      bubbles: true
    }))
  }
}
